import React from 'react';

const companies = [
  {
    name: '1818',
    tagline: 'Brands',
    render: () => (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900, fontSize: 38, letterSpacing: '-0.04em', color: 'var(--sm-navy)', lineHeight: 1 }}>1818</div>
        <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 11, letterSpacing: '0.42em', color: 'var(--sm-navy)' }}>BRANDS</div>
      </div>
    ),
  },
  {
    name: 'AR',
    tagline: 'Denim LLC',
    render: () => (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300, fontSize: 40, letterSpacing: '0.02em', color: 'var(--sm-navy)', lineHeight: 1 }}>AR</div>
        <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: 10, letterSpacing: '0.32em', color: 'var(--sm-navy)' }}>DENIM LLC</div>
      </div>
    ),
  },
  {
    name: 'Home Fix',
    tagline: 'LLC',
    render: () => (
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800, fontSize: 26, letterSpacing: '-0.015em', color: 'var(--sm-navy)', lineHeight: 1 }}>Home Fix</div>
        <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 12, letterSpacing: '0.18em', color: 'var(--sm-navy)' }}>LLC</div>
      </div>
    ),
  },
];

export default function GroupCompaniesBanner() {
  return (
    <section style={{ background: 'var(--sm-ivory)', borderTop: '1px solid var(--sm-line)', borderBottom: '1px solid var(--sm-line)', padding: '56px 0' }}>
      <div className="container-x">
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 14 }}>
            <span className="hairline" />
            <span className="overline">Group Companies</span>
            <span className="hairline" />
          </div>
          <div style={{ marginTop: 12, fontSize: 13, color: 'var(--sm-muted)', letterSpacing: '0.02em' }}>
            A portfolio of operating businesses under ES Investments Management LLC.
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', alignItems: 'center', justifyItems: 'center', gap: 32 }} className="logo-strip">
          {companies.map((c, i) => (
            <div key={c.name} style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px 24px',
              minHeight: 96,
              borderRight: i < companies.length - 1 ? '1px solid var(--sm-line)' : 'none',
              opacity: 0.82,
              transition: 'opacity 250ms ease, transform 400ms cubic-bezier(.2,.7,.2,1)',
              cursor: 'default',
            }}
              onMouseEnter={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.opacity = '0.82'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              {c.render()}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .logo-strip { grid-template-columns: repeat(2, 1fr) !important; gap: 24px !important; }
          .logo-strip > div { border-right: none !important; border-bottom: 1px solid var(--sm-line); padding: 24px !important; }
          .logo-strip > div:nth-last-child(-n+2) { border-bottom: none; }
        }
      `}</style>
    </section>
  );
}
